export const USERNAME_MAX_LENGTH = 20;
export const USERNAME_MIN_LENGTH = 3;
export const NAME_MAX_LENGTH = 20;
export const NAME_MIN_LENGTH = 3;

export const ONBOARDING_DRAFT_KEY = "onboarding_draft";
